<template>
    <div class="c-app flex-row align-items-center">
        <CContainer>
            <CRow class="justify-content-center">
                <CCol md="8">
                    <CCardGroup>
                        <CCard class="p-4">
                            <CCardBody>
                              <b-form @submit="onSubmit">
                                  <h1>Login</h1>
                                  <p class="text-muted">Sign In to your account</p>
                                  <CInput :addInputClasses="{'is-invalid': $v.username.$error}" v-model="username" placeholder="Email"
                                          invalid-feedback="Email is required">
                                        <template #prepend-content>
                                            <CIcon name="cil-user"/>
                                        </template>
                                  </CInput>

                                    <CInput v-model="password" placeholder="Password" type="password" autocomplete="curent-password"
                                            :addInputClasses="{'is-invalid': $v.password.$error}"
                                            invalid-feedback="Password is required">
                                        <template #prepend-content>
                                            <CIcon name="cil-lock-locked"/>
                                        </template>
                                    </CInput>
<!--                                <div class="form-check">-->
<!--                                  <input type="checkbox" v-model="rememberMe" class="form-check-input" id="rememberMe">-->
<!--                                  <label class="form-check-label" for="rememberMe">Remember me for a week</label>-->
<!--                                </div>-->
                                    <CRow>
                                        <CCol col="6" class="text-left">
                                            <b-button type="submit" variant="primary" class="px-4">Login</b-button>
                                        </CCol>
                                        <CCol col="6" class="text-right">
                                            <CButton color="link" to="/forgot-password" class="px-0">Forgot password?</CButton>
                                            <CButton color="link" to="/register" class="d-lg-none">Register now!</CButton>
                                        </CCol>
                                    </CRow>
                                </b-form>
                            </CCardBody>
                        </CCard>
                        <CCard color="primary"
                                text-color="white"
                                class="text-center py-5 d-md-down-none"
                                body-wrapper>
                            <CCardBody>
                                <h2>Sign up</h2>
                                <p></p>
                                <CButton @click="$router.push('register')" color="light"
                                        variant="outline"
                                        size="lg">
                                    Register Now!
                                </CButton>
                            </CCardBody>
                        </CCard>
                    </CCardGroup>
                </CCol>
            </CRow>
        </CContainer>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      rememberMe: false
    }
  },
  created () {
    if (this.$loading.isShow === true) {
      this.$loading.hide()
    }
    this.$store.dispatch('logout')
  },
  methods: {
    onSubmit (event) {
      event.preventDefault()

      if (this.$v.username.$invalid || this.$v.password.$invalid) {
        this.$v.$touch()
        return
      }

      this.$loading.show()
      this.$store.dispatch('login', {
        username: this.username,
        password: this.password
        // rememberMe: this.rememberMe
      }, { root: true }).then(response => {
        this.$loading.hide()
        if (response && response.status === 200) {
          this.$store.dispatch('fetch')
            .then(status => {
              if (status && status === 200) {
                this.$router.push({ name: 'Home' })
              }
              this.$loading.hide()
            })
          this.$store.dispatch('fetchCarrierDetails', { root: true })
        } else {
          this.$toastr.error(response.data.message)
        }
      }, (error) => {
        this.$loading.hide()
        if (error.response) {
          this.$toastr.error(error.response.data.message)
        } else {
          this.$toastr.error(error.message)
        }
      })
    }
  },
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  }
}
</script>
